import {
    usePatchCartPromotionCouponMutation,
    useDeleteCartPromotionCouponMutation,
} from 'store/api-slice/hooks'

export const useCouponCode = () => {
    const [deleteCoupon, deleteCouponStatus] =
        useDeleteCartPromotionCouponMutation()
    const [addCoupon, addCouponStatus] = usePatchCartPromotionCouponMutation()

    const isCouponCodeProcessing =
        addCouponStatus.isLoading || deleteCouponStatus.isLoading

    return {
        addCoupon,
        deleteCoupon,
        isCouponCodeProcessing,
    }
}
